"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgAccount = function (props) {
    var color = props.color;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M16.05 18.901a7.73 7.73 0 0 0-.012-.006C14.915 18.337 13.571 18 12 18c-1.689 0-3.057.29-4.122.858A7.963 7.963 0 0 0 12 20c1.478 0 2.862-.4 4.05-1.099zm1.7-1.338a8 8 0 1 0-11.531-.033C7.703 16.502 9.64 16 12 16c1.89 0 3.538.413 4.929 1.105.308.153.581.307.82.458zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" }));
};
exports.default = factorySvgIcon_1.default(SvgAccount);
//# sourceMappingURL=SvgAccount.js.map